import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toArray, omit } from 'lodash';
import MediaQuery from 'react-responsive';

import { PATH } from '../../constants/path';
import { HAS_INSTANT_DISCOUNT } from '../../constants/index';
import { SUB_NAV_CATEGORIES } from '../../services/nav/constants';
import { MENU_VERSION_MENU_MOBILE_SLIDE } from '../../services/header/constants';

import { showSubNav, hideSubNav } from '../../services/nav/actions';

import LocalizedNavLink from '../router/LocalizedNavLink';

import { StyledNav } from './NavComponentStyle';
import { getI18nByApp } from '../../services/i18n/selector';

class MenuComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOffline: false,
            isEbon: false
        };
    }

    toggleOffline = value => {
        this.setState({ isOffline: value });
    };
    toggleEbon = value => {
        this.setState({ isEbon: value });
    };

    showSubNav = subNav => this.props.showSubNav(subNav);
    hideSubNav = () => this.props.hideSubNav();

    onMouseEnterCategories = () => this.showSubNav(SUB_NAV_CATEGORIES);
    onMouseLeaveCategories = () => this.hideSubNav();

    showCategories = (isOffline, isEbon) => () => {
        this.toggleOffline(isOffline);
        this.toggleEbon(isEbon);
        this.onMouseEnterCategories();
    };

    onClickCategories = (matches, isOffline, isEbon) => e => {
        if (!matches) {
            this.toggleOffline(isOffline);
            this.toggleEbon(isEbon);
            e.preventDefault();
            if (!this.props.subNavDisplayed) {
                this.showSubNav(SUB_NAV_CATEGORIES);
            } else {
                this.hideSubNav();
            }
        }
    };

    makeOnClickCategories = (matches, isOffline, isEbon) =>
        this.onClickCategories(matches, isOffline, isEbon);

    render() {
        const { i18n, stateOpenMenuMobileSlide, versionOpenMenuMobileSlide, location } = this.props;

        const EbonDirectoryUrl = `/${PATH.EBON}/`;

        return (
            <StyledNav
                className={`menu menu-mobile-slide ${
                    stateOpenMenuMobileSlide &&
                    versionOpenMenuMobileSlide === MENU_VERSION_MENU_MOBILE_SLIDE
                        ? 'open'
                        : ''
                }`}
                id="menu">
                <div className="conteneur menu-conteneur flex-container-h">
                    <MediaQuery query="(min-width: 769px)">
                        {matches => (
                            <LocalizedNavLink
                                to={PATH.CASHBACK_EBON_MOST_POPULAR_PATH}
                                className={`menu-sous-menu ${
                                    location.pathname.indexOf(EbonDirectoryUrl) !== -1
                                        ? 'actif'
                                        : ''
                                }`}>
                                {getI18nByApp(i18n, 'feature.header.menu.EBON_OFFERS')}
                            </LocalizedNavLink>
                        )}
                    </MediaQuery>
                    <LocalizedNavLink to={PATH.HOW_IT_WORK_PATH} activeClassName="actif">
                        {getI18nByApp(i18n, 'feature.header.menu.HOW_IT_WORKS')}
                    </LocalizedNavLink>
                    <LocalizedNavLink to={PATH.EBONS_REMINDER_PATH} activeClassName="actif">
                        {HAS_INSTANT_DISCOUNT
                            ? getI18nByApp(
                                  i18n,
                                  'feature.header.MEMBER_NO_AUTH_NAV.MY_EBONS_INSTANT_DISCOUNT'
                              )
                            : getI18nByApp(i18n, 'feature.header.MEMBER_NO_AUTH_NAV.MY_EBONS')}
                    </LocalizedNavLink>
                    <LocalizedNavLink to={PATH.FAQ_PATH} activeClassName="actif">
                        {getI18nByApp(i18n, 'feature.header.menu.FAQ')}
                    </LocalizedNavLink>
                    <LocalizedNavLink to={PATH.CONTACTREQUEST_PATH} activeClassName="actif">
                        {getI18nByApp(i18n, 'feature.header.menu.CONTACT')}
                    </LocalizedNavLink>
                </div>
            </StyledNav>
        );
    }
}

MenuComponent.propTypes = {
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    versionOpenMenuMobileSlide: PropTypes.string.isRequired,
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        stateOpenMenuMobileSlide: state.header.stateOpenMenuMobileSlide,
        versionOpenMenuMobileSlide: state.header.versionOpenMenuMobileSlide,
        i18n: state.i18n,
        categories: toArray(omit(state.category.categories, 'loading')),
        subNavDisplayed: !!state.nav.subNav,
        location: state.routing.location
    };
};

const mapDispatchToProps = {
    showSubNav,
    hideSubNav
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuComponent);



// WEBPACK FOOTER //
// ./src/components/header/NavComponent.js